var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"4d18ae7778b275356149901780ce60bc6db27317"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["legacy@interpals"]={id:"4d18ae7778b275356149901780ce60bc6db27317"};
      